module.exports = __webpack_public_path__ + "media/images/home/mini/5-f603deadc7609e9dafd651c420e535ae.png";